var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission flex-column flex-center"},[_c('img',{staticClass:"bg-img",attrs:{"src":require("./no-permission.png"),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v("暂无权限")]),_c('div',{staticClass:"des"},[_vm._v("您当前绑定的系统账号暂无系统权限，请通过OA进行权限申请。 如有疑问，请联系纵队信息负责人咨询。")])])
}]

export { render, staticRenderFns }